export default __webpack_public_path__ + "static/media/tarra-picturemark-l.b09a99e3.svg";